export default __webpack_public_path__ + "static/insurent-71ab6a4e6d6392bb1243f536fdec2d5e.png";